<template>
  <div>
    <el-dialog :title="title" visible  top="10vh" @close="onCancel">
      <el-table border :row-class-name="tableRowClassName" :data="paginationData" max-height="460" v-loading="loading" >
        <!-- 实体名称en -->
        <el-table-column
          prop="fapiaoToEntity"
          width="200"
          show-overflow-tooltip
          :label="$t('admin.fapiaoToEntity')"
        >
          <template slot="header" slot-scope="scope">
            <div class="table-header">
              <div class="header-with-popup">
                {{ $t("admin.fapiaoToEntity") }}
                <InputPopover
                  :value.sync="searchForm.fapiaoToEntity"
                  :hide-popper-search="hidePopperSearch"
                ></InputPopover>
              </div>
            </div>
          </template>
        </el-table-column>
        <!-- 金额 -->
        <el-table-column
          prop="fapiaoAmount"
          width="140"
          align="right"
          show-overflow-tooltip
          :label="$t('admin.fapiaoAmount')"
        >
          <template slot="header" slot-scope="scope">
            <div class="table-header header-with-mount">
              <div class="header-with-popup">
                <span v-html='$t("admin.fapiaoAmount")'></span>
                <el-popover placement="bottom" trigger="click" @hide="hidePopperSearch">
                  <div slot="reference" class="th-filter-down">
                    <slot name="icon">
                      <i
                        :class="[
                          'el-icon-arrow-down',
                          searchForm.fapiaoAmountRange && searchForm.fapiaoAmountRange.length > 0
                            ? 'el-icon-arrow-down-active'
                            : '',
                        ]"
                      ></i>
                    </slot>
                  </div>
                  <input-number-range
                    v-model="searchForm.fapiaoAmountRange"
                    class="input-amount-container"
                    :precision="2"
                  />
                </el-popover>
              </div>
            </div>
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.fapiaoAmount | formatNumThousandths }}</span>
          </template>
        </el-table-column>
        <!-- 发票日期 -->
        <el-table-column
          prop="fapiaoIssueDate"
          show-overflow-tooltip
          :label="$t('admin.fapiaoIssueDate')"
          width="120"
        >
          <template slot="header" slot-scope="scope">
            <div class="table-header">
              <div class="header-with-popup">
                {{ $t("admin.fapiaoIssueDate") }}
                <DatePickerPopover
                  :value.sync="searchForm.fapiaoIssueDateRange"
                  :hide-popper-search="hidePopperSearch"
                ></DatePickerPopover>
              </div>
            </div>
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.fapiaoIssueDate | formatDate }}</span>
          </template>
        </el-table-column>
        <!-- 发票类型 -->
        <el-table-column prop="fapiaoType"   show-overflow-tooltip  >
          <template #header>
            <div class="table-header">
                <div class="header-with-popup">
                {{ $t("admin.fapiaoType") }}
                <MultiSelectPopver
                  :hide-popper-search="hidePopperSearch"
                  :value.sync="searchForm.fapiaoTypeList"
                  label-key="label"
                  value-key="value"
                  :input-filter-key="['label', 'value']"
                  :options="categoryOptions"
                ></MultiSelectPopver>
              </div>
            </div>
          </template>
          <template slot-scope="scope">
            {{ $t(`admin.${scope.row.fapiaoType}`) }}
          </template>
        </el-table-column>
        <!-- 发票号 -->
        <el-table-column
          prop="fapiaoNumber"
          width="180"
          show-overflow-tooltip
          :label="$t('admin.fapiaoNumber')"
        >
          <template slot="header" slot-scope="scope">
            <div class="table-header">
              <div class="header-with-popup">
                {{ $t("admin.fapiaoNumber") }}
                <InputPopover
                  :value.sync="searchForm.fapiaoNumber"
                  :hide-popper-search="hidePopperSearch"
                ></InputPopover>
              </div>
            </div>
          </template>
        </el-table-column>
        <!-- 发票关联号 -->
        <!-- <el-table-column
          prop="fapiaoReferenceCode"
          width="140"
          show-overflow-tooltip
          :label="$t('admin.fapiaoReferenceCode')"
        >
          <template slot="header" slot-scope="scope">
            <div class="table-header">
              <div class="header-with-popup">
                {{ $t("admin.fapiaoReferenceCode") }}
                <InputPopover
                  :value.sync="searchForm.fapiaoReferenceCode"
                  :hide-popper-search="hidePopperSearch"
                ></InputPopover>
              </div>
            </div>
          </template>
        </el-table-column> -->
        <el-table-column
          prop="pdfFileInfo"
          class-name="file-name-cell"
          :label="$t('admin.fapiaoPdf')"
          width="130"
        >
          <template slot-scope="scope">
            <span v-if="calcDisableDownload(scope.row.pdfFileInfo)">
              {{ `${$t('admin.fapiao')}.pdf` }}
            </span>
            <span v-else class="file-name can-download">
              <el-tooltip  effect="dark" :content="$t('preview')" placement="top-start" >
                <span class="icon-preview" @click="previewPdf(scope.row)"><i class="el-icon-view" /></span>
              </el-tooltip>
              <el-tooltip  effect="dark" :content="(scope.row.pdfFileInfo || {name: ''}).name" placement="top-start" >
                <span @click="onFileDownload(scope.row.pdfFileInfo)">
                <i class="el-icon-download" />
                {{ `${$t('admin.fapiao')}.pdf` }}
              </span>
              </el-tooltip>
              
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="xmlFileInfo"
          class-name="file-name-cell"
          :label="$t('admin.fapiaoXml')"
          width="120"
        >
          <template slot-scope="scope">
            <span v-if="calcDisableDownload(scope.row.xmlFileInfo)">{{ `${$t('admin.fapiao')}.zip` }}</span>
            <span v-else class="file-name can-download">
              <el-tooltip  effect="dark" :content="(scope.row.xmlFileInfo || {name: ''}).name" placement="top-start" >
                <span @click="onFileDownload(scope.row.xmlFileInfo)">
                  <i class="el-icon-download" />
                  {{ `${$t('admin.fapiao')}.zip` }}
                </span>
              </el-tooltip>
            </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="wl-pagination"
        :total="pager.total"
        :current-page="pager.pageNum"
        :page-size="pager.pageSize"
        :page-sizes="[10, 50, 100]"
        layout="prev, pager, next, sizes, total"
        @size-change="onSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import API from "@/api";
import DatePickerPopover from "@/components/common/DatePickerPopover.vue";
import InputNumberRange from "@/components/common/InputNumberRange";
import InputPopover from "@/components/common/InputPopover.vue";
import MultiSelectPopver from "@/components/common/MultiSelectPopver.vue";
import { userPermission } from "@/mixins/userPermission.js";
import { dateFormat } from "@/utils";
import { downloadSingleFile, downloadBatchFiles } from "@/utils/useDownload";
import { fapiaoTypeOptions } from "./allCategory";

export default {
  name: "fapiao-detail",
  components: {
    MultiSelectPopver,
    DatePickerPopover,
    InputPopover,
    InputNumberRange,
  },
  props: {
    row: Object,
    onCancel: Function,
    id: String,
    curUserName: String,
    downloadAble: Boolean,
  },
  computed: {
    ...mapGetters("common", {
      getSite: "getSite",
      getUser: "getUser",
    }),
    isKpmgUser() {
      return this.getUser.userType === "1";
    },
    title() {
      return `${this.$t("admin.fapiao")} (${this.$t("admin.invoice")} ${this.row.invoiceNumber})`;
    },
    categoryOptions() {
      return fapiaoTypeOptions.map((item) => ({
        label: this.$t(`admin.${item}`),
        value: item,
      }));
    },
  },
  mixins: [userPermission],
  data() {
    return {
      historyVisible: false,
      loading: false,
      historyData: [],
      searchForm: {
        fapiaoToEntity: "",
        entityNameCn: "",
        fapiaoAmountRange: [],
        fapiaoTypeList:[]
      },

      paginationData: [],
      pager: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  watch: {
    id: {
      immediate: true,
      handler(value) {
        if (value) {
          this.getFapiaoInfo();
        }
      },
    },
  },
  mounted() {},
  methods: {
    async previewPdf(row){
      const res = await API.clientAdmin.getPdfPreview({
              fapiaoId:row.id
          })
        var file = new Blob([res], { type: 'application/pdf;charset=utf-8' })
        const pdfBlob = window.URL.createObjectURL(file)
        window.open(pdfBlob)
    },
    async getFapiaoInfo() {
      this.loading = true
      const params = {
        invoiceIdList: [this.row.id],
        siteId: this.getSite.siteId,
        ...this.pager,
        minFapiaoAmount:
          this.searchForm.fapiaoAmountRange && this.searchForm.fapiaoAmountRange
            ? this.searchForm.fapiaoAmountRange[0]
            : null,
        maxFapiaoAmount:
          this.searchForm.fapiaoAmountRange && this.searchForm.fapiaoAmountRange
            ? this.searchForm.fapiaoAmountRange[1]
            : null,
        startFapiaoIssueDate:
          this.searchForm.fapiaoIssueDateRange && this.searchForm.fapiaoIssueDateRange[1]
            ? dateFormat(new Date(this.searchForm.fapiaoIssueDateRange[0]), "yyyy-MM-dd")
            : null,
          endFapiaoIssueDate:
          this.searchForm.fapiaoIssueDateRange && this.searchForm.fapiaoIssueDateRange[1]
            ? dateFormat(new Date(this.searchForm.fapiaoIssueDateRange[1]), "yyyy-MM-dd")
            : null,
        fapiaoToEntity:this.searchForm.fapiaoToEntity,
        fapiaoTypeList: this.searchForm.fapiaoTypeList,
        fapiaoNumber: this.searchForm.fapiaoNumber,
        fapiaoReferenceCode: this.searchForm.fapiaoReferenceCode,
      };

      const { code, data } = await API.clientAdmin.queryFapiaoInfo(params);
      if (code == "1") {
        if (data.records) {
          this.paginationData = data.records;
          this.pager.total = data.total;
        }else{
          this.paginationData = [];
          this.pager.total = 0;
        }
      } else {
        this.$message.error(this.$t(code));
      }
      this.loading = false
    },
    hidePopperSearch() {
      this.getFapiaoInfo();
    },
    /**
     * 客户之间不允许相互下载 || 没有下载权限
     *
     * @param {*} row
     */
    calcDisableDownload(row) {
      return (
        !this.hasPermission("download") ||
        (this.getUser.userType === "2" &&
          !this.downloadAble &&
          row.uploadBy &&
          row.uploadBy.indexOf("@") !== -1 &&
          row.uploadBy.indexOf(this.curUserName) == -1)
      );
    },

    tableRowClassName({ row, rowIndex }) {
      if (row.uploadBy && row.uploadBy.indexOf("@") === -1) {
        return "kp-update-row";
      }
      return "";
    },
    onSizeChange(size) {
      this.pager.pageNum = 1;
      this.pager.pageSize = size;
      this.getFapiaoInfo();
    },
    handleCurrentChange(val) {
      this.pager.pageNum = val;
      this.getFapiaoInfo();
    },
    onFileDownload(row) {
      const fileInfo = {
        id: this.id,
        fileId: row.fileId,
        siteEntityId: this.id,
        siteId: this.getSite.siteId,
        source: "fapiao",
        fileName: row.name,
      };
      downloadSingleFile(fileInfo);
    },
    async queryFileHistory(fileName, groupEntityTopicId) {
      try {
        this.historyVisible = true;
        this.loading = true;
        const { data, code } = await API.pbc.queryFileHistory({
          fileName,
          groupEntityTopicId,
          siteId: this.getSite.siteId,
          source: this.activeTab,
        });
        if (code === "1") {
          if (data.length > 0) data.shift();
          if (data.length === 0) {
            this.clearHistoryFlag(fileName);
          }
          this.historyData = data.map((v) => {
            v.groupEntityTopicId = groupEntityTopicId;
            return v;
          });
        } else {
          this.$message.error(this.$t(code));
        }
        this.loading = false;
      } catch (err) {
      } finally {
      }
    },
    toogleFileHistoryVisible() {
      this.historyVisible = !this.historyVisible;
    },
  },
};
</script>

<style scoped>
::v-deep .el-dialog{
  width: 1180PX;
}
.table-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: left;
}
.file-name-cell .can-download {
  cursor: pointer;
  user-select: none;
  color: rgb(120, 120, 195);
}
.file-name-cell .file-name {
  display: inline-block;
  margin-right: 10px;
}

.file-name-cell .can-download:hover {
  color: rgb(120, 120, 195);
  text-decoration: underline;
}
.pointer {
  cursor: pointer;
  color: #3879eb;
}
.icon-preview {
  margin-right: 10px;
}
.el-icon-view,
.el-icon-download {
  color: #3879eb;
  font-weight: bold;
}
.delete {
  color: #fd349c;
  cursor: pointer;
}
::v-deep .kp-update-row {
  background: #0091da;
  color: #ffffff;
}
::v-deep .kp-update-row .el-icon-download {
  color: #fff;
}
::v-deep .kp-update-row:hover .el-icon-download {
  color: #3879eb;
}
::v-deep .kp-update-row .pointer {
  color: #fff;
}
::v-deep .kp-update-row:hover .pointer {
  color: #3879eb;
}
::v-deep .el-table tr:hover {
  color: #636363;
}
.action-item {
  margin: 0 5px;
}
.action-item:hover {
  cursor: pointer;
  text-decoration: underline;
}
</style>
